import styled, { css } from 'styled-components';
import { Link } from '@chegg-ui/link';
import { colors } from '@chegg-ui/theme';
import { fadeIn, fadeOut } from "../../common/styles/animations.styles";
export var ToastWrapperSC = styled.div.withConfig({
  componentId: "sc-2ob0g6-0"
})(["", ""], function (_ref) {
  var fadeType = _ref.fadeType;
  return css(["animation:", " 0.7s forwards;"], fadeType === 'fadeIn' ? fadeIn : fadeOut);
});
export var BannerLinkSC = styled(Link).withConfig({
  componentId: "sc-2ob0g6-1"
})(["color:", ";text-decoration:'underline';cursor:pointer;"], colors.dark);